module.exports = __webpack_public_path__ + "img/award-bg-en.aed1fa06.png";